import React, { useState } from "react";
import background from "../../assets/images/screenBackground.jpg";
import { Modal, Form, Input, Button, Row, Col, notification, Spin } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { componentStyles } from "./CredentialsStyles";
import { postNewPassword } from "../../api/password";
import ClipLoader from "react-spinners/ClipLoader";
import rules from "../../validations";
import { useNavigate } from "react-router-dom";
import {
  IS_PASSWORD_SYSTEM_GENERATED,
  IS_PSUEDO_NAME_SYSTEM_GENERATED,
} from "../../redux/constants/Auth";
import Footer from "../../components/layout/Footer";

const screenBackground = {
  backgroundImage: `url(${background})`,
  backgroundSize: "cover",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
  width: "100%",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const Password = () => {
  const [passwordData, setPasswordData] = useState();
  const [loader, setLoader] = useState(false);
  const [messageApi, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  const handleInputChange = (name, value) => {
    setPasswordData({ ...passwordData, [name]: value });
  };

  const onFinish = () => {
    setPasswordRequest();
  };

  const setPasswordRequest = async () => {
    try {
      setLoader(true);
      const response = await postNewPassword(passwordData);
      response.message && setLoader(false);
      if (response.message) {
        const isUsername =
          localStorage.getItem(IS_PSUEDO_NAME_SYSTEM_GENERATED) === "true"
            ? true
            : false;
        localStorage.setItem(IS_PASSWORD_SYSTEM_GENERATED, "false");
        isUsername ? navigate("/set-username") : navigate("/landing-page");
      } else {
        messageApi.error({
          message: "Error",
          description: `Password couldn't be updated. Please contact your admin`,
        });
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  return (
    <>
      <div style={screenBackground}>
        <Modal
          visible={true}
          centered
          mask={false}
          closable={false}
          footer={null}
          title={null}
          width={544}
        >
          {contextHolder}
          <Form onFinish={onFinish}>
            <Row justify="center">
              <Col span={22} style={componentStyles.rowContainer}>
                Set Password
              </Col>
              <Col span={22} style={componentStyles.usernameContainer}>
                <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name="password"
                  label={
                    <span style={componentStyles.formLabel}>New Password</span>
                  }
                  rules={rules.newPassword}
                  validateTrigger="onBlur"
                >
                  <Input.Password
                    placeholder="Enter New Password"
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                    onChange={(val) =>
                      handleInputChange("password", val.target.value)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={22}>
                <Form.Item
                  style={{ marginTop: 16 }}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name="confirm_password"
                  label={
                    <span style={componentStyles.formLabel}>
                      Confirm Password
                    </span>
                  }
                  validateTrigger="onBlur"
                  rules={rules.confirmPassword}
                >
                  <Input.Password
                    placeholder="Enter Confirm Password"
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                    onChange={(val) =>
                      handleInputChange("confirmPassword", val.target.value)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={22}>
                <Row justify="center">
                  <Button
                    style={componentStyles.submitBtn}
                    type="primary"
                    htmlType="submit"
                  >
                    {loader ? (
                      <ClipLoader
                        color="#fff"
                        loading={loader}
                        size={15}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    ) : (
                      <span>Submit</span>
                    )}
                  </Button>
                </Row>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
    </>
  );
};

export default Password;
